import http from './public'
import { getStore } from '/utils/storage'

export const getTaskResult = (puuid) => {
  return http.fetchGet(`/picSearch/wes/AICreate/task-result/${puuid}`)
}

export const upload = (formData) => {
  return http.fetchPost('/picSearch/wes/image/uploadAIImage', formData)
}

export const textToImage = (params) => {
  params.userId = getStore('userId')
  return http.fetchPost('/picSearch/wes/AICreate/text-to-image', params)
}

export const imageToImage = (params) => {
  params.userId = getStore('userId')
  return http.fetchPost('/picSearch/wes/AICreate/image-to-image', params)
}

export const tryOn = (params) => {
  params.userId = getStore('userId')
  return http.fetchPost('/picSearch/wes/AICreate/try-on', params)
}



// WEBPACK FOOTER //
// ./src/api/aiCreate.js